import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import 'dayjs/locale/uk';
import 'dayjs/locale/en';
import { getFormat, getLocale } from './datePickerHelpers';

dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);

const CustomDatePicker = ({ type, suffixIcon, children, ...rest }) => {
    const { i18n } = useTranslation();

    useEffect(() => {
        switch (i18n.language) {
            case 'uk':
                dayjs.locale('uk');
                break;
            default:
                dayjs.locale('en');
        }
    }, [i18n.language]);

    return (
        <DatePicker
            locale={getLocale(i18n.language)}
            format={getFormat(type)}
            suffixIcon={suffixIcon || <i className="fi-rr-calendar" />}
            {...rest}
        >
            {children}
        </DatePicker>
    );
};

export default CustomDatePicker;
